document.addEventListener("DOMContentLoaded", function() {
  // Seleziona l'ultima .tab-custom dentro .main-content
  const lastTabCustom = document.querySelector("#shopify-section-template--23863742824777__product_information_4YYYcm .tab-custom");
  
  if (lastTabCustom) {
    // Seleziona il primo link mobile dentro l'ultima tab-custom
    const firstLink = lastTabCustom.querySelector(".more-info-tabs__nav-link.mobile");
    
    if (firstLink) {
      // Aggiunge la classe 'active'
      firstLink.classList.add("active");

      // Ottiene l'id dal data-id del link
      const targetId = firstLink.getAttribute("data-id");
      
      // Seleziona il tab corrispondente all'interno della stessa tab-custom
      const tab = lastTabCustom.querySelector("#" + targetId);
      
      // Mostra il tab
      if (tab) {
        tab.style.display = "block";
      }
    }
  }
});
